<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <!-- <el-breadcrumb-item :to="{ path: '/home' }" key="dashboard">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item key="dashboard">首页</el-breadcrumb-item> -->
      <!-- <a class="iconfont icon-home" @click.prevent="handleHomeClick">首页</a> -->
      <el-breadcrumb-item key="dashboard">
        <a @click.prevent="handleHomeClick">首页</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item,index) in breadList" :key="item">
        <!-- v-if="index === breadList.length- 1" -->
        <span v-if="index === breadList.length-1" class="no-redirect" @click.prevent="handleLink(item,index)">{{ item }}</span>
        <a v-else @click.prevent="handleLink(item,index)">{{ item }}</a>
      </el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-for="item in breadList" :key="item" :to="item.path">{{item.name}}</el-breadcrumb-item> -->
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["sidebarCollapse", "showLogo"]),
    breadList() {
      return this.$route.meta.breadcrumbs;
    },

  },
  methods: {
    handleLink(item, index) {
      if (index === 0) { //为0 才跳转
        console.log("根路由跳转当前页面",this.breadList[1])
        this.$router.push({ name: this.breadList[1] }); 
      }
      else{
        this.$router.push({ name: item }); 
      }
        
    },
    // 点击首页面包屑
    handleHomeClick() {
      // this.$store.dispatch("changeActiveIndex", "1");
      // sessionStorage.setItem("activeIndex", "1");
      // this.$router.push("/home");
      this.$router.push("/dashboard"); //6/9改为首页 
    }
  }
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    // color: #97a8be;
    color: #409EFF;
    cursor: text;
    font-weight:bold;
  }
}
</style>
